import React, { createContext, useContext, useEffect, useState } from 'react';
import { useConfig } from '../../../contexts/config-context';
import useInitialAppointmentState from '../actions/initial-appointment-state';
import { initialDefaultState } from '../actions/initial-appointment-state/utils';
const AppointmentFieldContext = /*#__PURE__*/createContext({
  appointmentState: {},
  setAppointmentState: () => {}
});
export const AppointmentContextProvider = _ref => {
  let {
    appointmentFieldProps,
    children
  } = _ref;
  const {
    isEditor,
    isComposer
  } = useConfig();
  const [appointmentState, setAppointmentState] = useState(() => initialDefaultState({
    appointmentFieldProps,
    isEditor,
    isComposer
  }));
  const initialAppointmentState = useInitialAppointmentState(appointmentFieldProps);
  useEffect(() => {
    if (initialAppointmentState) {
      setAppointmentState({
        ...appointmentState,
        ...initialAppointmentState
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialAppointmentState]);
  return /*#__PURE__*/React.createElement(AppointmentFieldContext.Provider, {
    value: {
      appointmentFieldProps,
      appointmentState,
      setAppointmentState: nextState => {
        return setAppointmentState({
          ...appointmentState,
          ...nextState
        });
      }
    }
  }, children);
};
export const useAppointmentContext = () => useContext(AppointmentFieldContext);
//# sourceMappingURL=appointment-context.js.map